import React, { memo, Fragment } from "react";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// utils
import { isEqual } from "@swiggy-private/js-utils";

export interface IOptionText {
    matchStr: string;
    fullStr: string;
}

const OptionText = ({ matchStr, fullStr }: IOptionText) => {
    const textArr = fullStr?.split(new RegExp(`(${matchStr})`, `gi`));

    return (
        <Text maxLines={1} variant="V2.body1.neutral.regular" data-testid={fullStr}>
            {textArr.map((text: string, index: number) => {
                if (isEqual(text.toLowerCase(), matchStr.toLowerCase())) {
                    return <b key={index}>{text}</b>;
                }
                return <Fragment key={index}>{text}</Fragment>;
            })}
        </Text>
    );
};

export default memo(OptionText);
